module.exports = __webpack_public_path__ + "img/products_3.0e419c26.png";